import React from 'react';
import Section from './Section';
import { OVERVIEW_EN } from './index';

const OverViewAdvice = () => {
  const [selectedTitle, setSelectedTitle] = React.useState('');

  return (
    <ul className="m-0 list-none">
      <Section
        title="缺少实习经验的应届生应该如何写简历？"
        adviceIndex={1}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-overview-5/"
        sectionGroup={OVERVIEW_EN}
        isRecommend={true}
        defaultChecked={true}
      >
        <>
          <ul className="m-0 list-none leading-6.5">
            <li className="mb-4">
              <strong>应届生的核心问题：</strong>
              对于应届生而言，缺少实习经验并不是本质问题，本质问题是在简历上缺少足够的信息量以让用人单位对你产生了解和正面印象。
            </li>
            <li className="mb-4">
              <strong>用人单位对职场新人的期望：</strong>
              <ul className="!ml-5 list-disc">
                <li>有对这个岗位的热情；</li>
                <li>有学习能力和意愿度；</li>
                <li>有一定的基础素质。</li>
              </ul>
            </li>
            <li className="mb-4">
              <strong>对应的解决办法：</strong>
              <ul className="!ml-5 list-disc">
                <li>
                  增加校园经历，包括以项目经历的方式来描述你在校期间做过的事情；
                </li>
                <li>
                  在描述方法中匹配用人单位对于职场新人在学习意愿度和基础能力上的要求。
                </li>
              </ul>
            </li>
            <li className="mb-4">
              <strong>具体方法：</strong>
              <ul className="!ml-5 list-disc">
                <li>对岗位的热情：在“个人总结”部分用简短段落表述。</li>
                <li>
                  学习能力和意愿度：详细描述专业课程、毕业论文、社团活动，重点展示你对于新领域的快速学习的过程。
                </li>
                <li>
                  基础素质：可以通过校园项目经历的方式来展开描述。这个经历可以是社团经历、校园活动或者课堂作业、小组讨论等，从中呈现你对这段经历的理解、对执行过程的把控、以及回顾反思的这些关键素质。
                </li>
              </ul>
            </li>
          </ul>
          <p className="leading-6.5">
            重要提醒：要用足够的信息量展示热情、学习能力和基础素质。将校园经历当作重要的职业准备，以专业的态度对待。
          </p>
        </>
      </Section>
      <Section
        title="什么才算是一封优秀的简历？"
        adviceIndex={2}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-overview-1/"
        sectionGroup={OVERVIEW_EN}
        isRecommend={true}
      >
        <ul className="m-0 list-none">
          <Section
            title="青铜段位：简历包含必要的信息，信息规范，没有明显的格式紊乱或错误。"
            showArrow={true}
          >
            <ul className="!ml-14 list-disc">
              <li>
                <strong>排版整洁：</strong>
                使用统一的字体、合适的项目符号和适当的缩进。
              </li>
              <li>
                <strong>内容清晰有序：</strong>
                正确地对模块进行排序，比如个人信息、工作经历、教育背景、技能等。
              </li>
              <li>
                <strong>无错别字和语法错误：</strong>
                确保简历中没有明显的拼写或语法问题，这会直接影响用人单位对你的专业性判断。
              </li>
            </ul>
          </Section>
          <Section title="白银段位：职业经历完整。" showArrow={true}>
            <p className="ml-8 mb-2">
              白银段位的简历应该能够全面展现你的职业背景：
            </p>
            <ul className="!ml-14 list-disc">
              <li>
                <strong>你做过什么：</strong>
                使用统一的字体、合适的项目符号和适当的缩进。
              </li>
              <li>
                <strong>你能做什么：</strong>
                通过技能、工具模块展示你的核心能力，尤其是与目标岗位相关的技能。
              </li>
              <li>
                <strong>你想做什么：</strong>
                通过“个人总结”部分表达你未来职业发展的方向和期望，明确你对目标岗位的兴趣。
              </li>
              <li>
                <strong>你是个怎样的人：</strong>
                通过职业经历、项目描述等细节，展示你的工作风格、沟通能力、领导力等软实力。
              </li>
            </ul>
          </Section>
          <Section
            title="黄金段位：呈现符合你职业定位的核心能力。"
            showArrow={true}
          >
            <p className="ml-8 mb-2">
              要达到黄金段位，你需要做到的不仅仅是完整的经历描述，而是精准呈现与你职业定位相匹配的核心能力：
            </p>
            <ul className="!ml-14 list-disc">
              <li>
                <strong>梳理自己的职业定位：</strong>
                简历中的内容应该反映出你对自己角色的清晰认知，无论你是执行者、项目管控者，还是成长中的管理者。
              </li>
              <li>
                <strong>清晰呈现核心能力：</strong>
                基于你期望的工作角色，描述自己在工作经历和项目经历中的核心能力，让用人单位感受到你的思考方式、决策能力、和执行力。
              </li>
            </ul>
          </Section>
          <Section
            title="钻石段位：简历塑造了饱满的职业形象。"
            showArrow={true}
          >
            <p className="ml-8 mb-2">
              饱满的职业形象指的是不仅展示你做过的工作内容，更通过简历自然流露出你独特的职业特质，让招聘方清晰感受到你的核心价值。这种简历让用人单位一读就能确认：“这就是我们要找的人。”
            </p>
            <ul className="!ml-14 list-disc">
              <li>
                <strong>精准展示职业特质：</strong>
                不仅仅罗列工作经历，而是让你的简历能够传递出你独特的职业特质。例如，领导力、创新能力、跨部门沟通能力等。
              </li>
              <li>
                <strong>统一的职业方向：</strong>
                基让你的经历、技能和职业目标形成一致的线索。在简历中传递出一种稳定、成长的职业发展脉络，避免让人产生角色或能力上的矛盾印象。
              </li>
              <li>
                <strong>细节处的真实和自然：</strong>
                职业形象并非刻意扮演，而是结合真实的工作经验、个人特质，通过简历表达出“这是我擅长的，也是我想要的”。这种自然感会增强你在面试时的自信和表现力。
              </li>
            </ul>
          </Section>
        </ul>
      </Section>
      <Section
        title="简历必须包含哪些核心内容？"
        adviceIndex={3}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-overview-2/"
        sectionGroup={OVERVIEW_EN}
      >
        <ul className="list-disc ml-5">
          <li className="mb-4">
            <strong>必备内容：</strong>个人信息、教育经历、工作经历。
          </li>
          <li>
            <strong>可选内容：</strong>
            包括个人总结、项目经历、技能和工具、作品集、证书和奖项、校园经历以及公益活动、兴趣爱好。
          </li>
        </ul>
        <p className="text-black/65 my-4">具体模块：</p>
        <ul className="m-0 list-none">
          <Section title="个人总结" showArrow={true}>
            <ul className="!ml-14 list-disc">
              <li>
                此模块作为你职业脉络的概览，在此处强调突出你的
                <strong>职业定位</strong>，以及过往围绕该职业定位所搭建的
                <strong>核心技能</strong>
                。最后告知你<strong>期待开展工作的方向</strong>。
              </li>
            </ul>
          </Section>
          <Section title="项目经历" showArrow={true}>
            <ul className="!ml-14 list-disc">
              <li>
                项目经历可以直观的反应你处在什么级别、你的工作水准，一定要写。
              </li>
              <li>
                重点是要呈现出你对这个项目的
                <strong>
                  思考、执行过程中如何解决挑战、以及展示最终的成果。
                </strong>
              </li>
              <li>
                选择2-3个不同时代、不同种类的事项上的项目进行描述（如果只描述一个项目，请确保此项目在你的职业经历中处在足够重要的位置，并足够出彩）。
              </li>
            </ul>
          </Section>
          <Section title="技能和工具" showArrow={true}>
            <ul className="!ml-14 list-disc">
              <li>首先，最主要列出的是和职位高度相关的、有一定门槛的技能。</li>
              <li>
                其次，推荐展示比较新的工具，而非比较旧的工具。例如，除非你是文秘类职位，否则不需要说：”熟练使用Word“，但你可以说”熟练掌握G-suite。
              </li>
            </ul>
          </Section>
          <Section title="作品集" showArrow={true}>
            <ul className="!ml-14 list-disc">
              <li>
                对设计、产品、写作和营销等这类常常需要用作品来说话的职位，建议增加作品集模块。
              </li>
              <li>
                简历上可以放作品概览，也可以放一个代表性的图片，不要放过多的内容。
              </li>
              <li>
                引导用人单位去搜索或获取你的作品（线下版简历不要只是放一个作品链接）。
              </li>
            </ul>
          </Section>
          <Section title="证书和奖项" showArrow={true}>
            <ul className="!ml-14 list-disc">
              <li>
                若有，就应该放，但也请注意奖项和证书的质量。一般需要是有一定影响力的奖项。
              </li>
            </ul>
          </Section>
          <Section title="校园经历" showArrow={true}>
            <ul className="!ml-14 list-disc">
              <li>
                如果你是应届生、或者是刚刚加入职场的新人（工作时间少于1年），那么可以考虑放这个模块。同时你的工作经验、实习经验越少，你在这个模块中的内容就应该越多，反之亦然。
              </li>
              <li>
                校园经历中可以展示你在校园中从事的社团活动、课外活动、甚至是课堂作业。某种程度上，这就是展示你能力的“校园项目经历”。
              </li>
            </ul>
          </Section>
        </ul>
      </Section>
      <Section
        title="简历的最佳长度：几页最合适？"
        adviceIndex={4}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-overview-3/"
        sectionGroup={OVERVIEW_EN}
      >
        <ul className="list-disc ml-5 leading-6.5">
          <li className="mb-4">
            <strong>以常见的A4纸简历为例：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                职业经历比较丰富的求职者：2-3页都没问题，但尽量不要超过3页；
              </li>
              <li>
                职业经历特别丰富的求职者：可以扩展到3页以上，但这种一般是有大量的作品、文献需要被呈现。尽量不要因为在工作经历、项目经历等模块上投入了太多的笔墨而使简历超过3页；
              </li>
              <li>职业经历不多的求职者：一般1-2 页。例如应届生、在校生等。</li>
            </ul>
          </li>
          <li>
            <strong>丰富经历的处理：</strong>应突出重点，避免过于啰嗦。
          </li>
          <li>
            <strong>经历较少的处理：</strong>
            努力挖掘可以展现职业形象的亮点，特别是从校园经历中找出，并用类似项目经历的方式展示，帮助用人单位理解你的基础素质、学习能力和执行力。
          </li>
        </ul>
      </Section>
      <Section
        title="为什么简历不必严格限制在一页内？"
        adviceIndex={5}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-overview-4/"
        sectionGroup={OVERVIEW_EN}
      >
        <ul className="list-disc ml-5 leading-6.5">
          <li>
            <strong>源自特定行业的惯例：</strong>
            将简历内容限制在一页纸内的规范主要源自金融和大型快消行业的校园招聘。这些行业通常面对大量的优秀人才申请，因此采用这种方式便于快速筛选。
          </li>
          <li>
            <strong>一页不适用于大多数行业：</strong>
            虽然这一规范曾被其他一些强势行业采用，但对于大多数常规行业而言，并不适用。大多数用人单位和人力资源部门更希望看到完整、丰富的信息，以全面了解应聘者的职业形象。
          </li>
          <li>
            <strong>避免过度精简：</strong>
            过度精简的简历可能会影响用人单位对求职者的全面判断，削弱其对求职者能力和经验的理解。因此，除非申请的岗位明确要求简历信息限制在一页纸，否则不必遵循这一限制。
          </li>
        </ul>
      </Section>
    </ul>
  );
};

export default OverViewAdvice;
